const LOCAL_STORAGE_PERSIST_KEYS = [
  'emoji-mart.frequently',
  'emoji-mart.last',
  // VoIP Recents "last viewed" timestamp drives the missed-call badge.
  // Wiping it on logout would re-flag every call in the API window as new.
  'voipLastRecentsViewedAt',
  // VoIP Reports timezone preference is per-device UI state.
  'voipReportsTimezone',
  // Messaging Reports Overview/Advanced choice is per-device UI state.
  'messagingReportsView',
];

export default LOCAL_STORAGE_PERSIST_KEYS;
